import { useEffect, useState } from "react";
import styled from "styled-components";
import { ReactComponent as IconEyeDefault } from "../Images/icon_eye_default.svg";
import { ReactComponent as IconEyeDisabled } from "../Images/icon_eye_disabled.svg";

const InputBoxTrans = ({
  message,
  type = "text",
  handleInput,
  handleEnterKey = null,
  code,
  hasError,
  handleTabKey = null,
  tabPressed = 0,
  id = null,
  inputRef = null,
}) => {
  const [isClicked, setIsClicked] = useState(false);
  const [isOn, setIsOn] = useState(false);
  const [openPw, setOpenPw] = useState(false);
  const [valueError, setValueError] = useState(false);
  const [value_count, setValue_count] = useState(0);
  const [tempValue, setTempValue] = useState("");

  const handleClick = () => {
    setIsClicked(true);
    setIsOn(true);
  };

  const handleValueCount = (e) => {
    const value = e.target.value;
    if (type === "companyName") {
      if (value.length <= 40) {
        setValue_count(value.length);
        setTempValue(value);
        setValueError(false);
      }
    } else {
      setTempValue(value);
    }
  };

  const validatePW = (password) => {
    const passwordRegex =
      /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,16}$/;
    return passwordRegex.test(password);
  };

  const handleBlur = (e) => {
    if (type === "password") {
      if (e.target.value === "") {
        handleInput(e.target.value, "비밀번호를 입력해주세요");
        setValueError(true);
        setIsClicked(false);
      } else if (!validatePW(e.target.value)) {
        handleInput(
          e.target.value,
          "비밀번호는 8~16자리(영문/숫자/특수문자)로 입력할 수 있어요."
        );
        setValueError(true);
      } else {
        handleInput(e.target.value, "");
        setValueError(false);
      }
      // handleTabKey(null);
    } else if (type === "companyName") {
      if (e.target.value === "") {
        handleInput(e.target.value, "기업명은 필수 항목입니다.");
        setValueError(true);
        setIsClicked(false);
      }
    } else {
      if (e.target.value === "") {
        handleInput(e.target.value, "기업 이메일을 입력해주세요");
        setValueError(true);
        setIsClicked(false);
      } else if (!e.target.value.includes("@")) {
        handleInput(e.target.value, "이메일 형식에 맞게 작성해주세요");
        setValueError(true);
      } else {
        handleInput(e.target.value, "");
        setValueError(false);
      }
    }
    setIsOn(false);
  };

  const togglePW = () => {
    setOpenPw((prev) => !prev);
  };

  useEffect(() => {
    if (type !== "companyName" && isClicked && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isClicked, inputRef]);

  return (
    <InputContainer
      onClick={handleClick}
      $isClicked={isClicked}
      $tabPressed={tabPressed}
      $code={code}
      $isOn={isOn}
      $valueError={valueError}
      type={type}
      $hasError={hasError}
      id={id}
      $inputRef={inputRef}
    >
      <div style={{ display: "flex" }}>
        <p className="place_holder">{message}</p>
        {!isClicked && type === "companyName" && (
          <p style={{ color: "#b0b0b0", margin: "15px 15px 0px auto" }}>
            {value_count}/40
          </p>
        )}
      </div>
      {(isClicked || tabPressed === 1) && <div className="clickWrapper" />}
      {(isClicked || tabPressed === 1) && (
        <InputWrapper type={type}>
          <input
            ref={inputRef}
            onBlur={handleBlur}
            autoFocus
            type={openPw ? "text" : type}
            value={tempValue}
            onChange={(e) => {
              handleValueCount(e);
              handleInput(e.target.value);
              setIsClicked(true);
            }}
            onKeyDown={(e) => {
              if (type === "companyName" && e.key === "Tab") {
                e.preventDefault();
              } else if (e.key === "Tab") {
                e.preventDefault();
                handleTabKey(id);
              } else if (e.key === "Enter" && handleEnterKey) {
                e.preventDefault();
                handleEnterKey();
              }
            }}
          />
          {type === "password" && (
            <div style={{ marginLeft: "auto", marginRight: "15px" }}>
              {openPw ? (
                <IconEyeDefault onClick={togglePW} />
              ) : (
                <IconEyeDisabled onClick={togglePW} />
              )}
            </div>
          )}
          {type === "companyName" && (
            <p style={{ color: "#b0b0b0", margin: "0 15px 0 auto" }}>
              {value_count}/40
            </p>
          )}
        </InputWrapper>
      )}
    </InputContainer>
  );
};

const InputContainer = styled.div`
  width: 400px;
  height: ${(props) =>
    props.$isClicked || props.$tabPressed === 1 ? "79px" : "55px"};
  border-radius: 10px;
  box-shadow: ${(props) => {
    if (props.$isOn) {
      return "inset 0 0 0 1px #1167ed";
    } else if (props.$tabPressed && props.$id === props.$tabPressed) {
      return "inset 0 0 0 1px #1167ed";
    } else if (
      props.$valueError ||
      props.$hasError ||
      props.$code !== 200 ||
      (props.$type !== "password" &&
        (props.$code === 1003 || props.$code === 1004))
    ) {
      return "inset 0 0 0 1px #f25c5c";
    } else {
      return "inset 0 0 0 1px #e4e4e4";
    }
  }};
  background-color: #ffffff;

  .place_holder {
    font-family: "notoSans";
    font-size: ${(props) =>
      props.$isClicked || props.$tabPressed === 1 ? "14px" : "16px"};
    color: #888888;
    padding-top: 16px;
    margin-left: 14px;
    cursor: pointer;
    transition: font-size 0.1s ease;
    width: 330px;
  }
  .clickWrapper {
    width: 386px;
    height: 20px;
    position: absolute;
    margin-top: -20px;
    margin-left: 14px;
    z-index: 1;
    background-color: transparent;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;

  > input {
    font-family: "notoSans-medium";
    font-size: 16px;

    width: 315px;
    height: 23px;
    border: none;

    margin-left: 14px;
    z-index: 2;
    &:focus {
      outline: none;
    }
  }
`;

export default InputBoxTrans;
